import { render, staticRenderFns } from "./QCRequire.vue?vue&type=template&id=35f44d87&scoped=true&"
import script from "./QCRequire.vue?vue&type=script&lang=js&"
export * from "./QCRequire.vue?vue&type=script&lang=js&"
import style0 from "./QCRequire.vue?vue&type=style&index=0&id=35f44d87&prod&scoped=true&lang=less&"
import style1 from "./QCRequire.vue?vue&type=style&index=1&id=35f44d87&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f44d87",
  null
  
)

export default component.exports